import { Fragment, ReactNode } from "react";
import { Dialog, Transition } from "@headlessui/react";
import classnames from "classnames";

interface Props {
  title?: ReactNode;
  children: ReactNode;
  isOpen: boolean;
  onClose(isOpen: boolean): void;
  className?: string;
  size?: 'sm';
}

export default function AppDialog({
  isOpen,
  onClose,
  children,
  className = "p-6",
  title,
  size,
}: Props) {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel
                className={classnames(
                  "w-full transform overflow-hidden rounded-2xl bg-light dark:bg-darkBg text-left align-middle shadow-xl transition-all",
                  {
                    "max-w-md": size === "sm",
                    "xl:max-w-6xl lg:max-w-4xl md:max-w-xl": size !== "sm",
                  }
                )}
              >
                {title && (
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-dark dark:text-light p-6"
                  >
                    {title}
                  </Dialog.Title>
                )}
                <div className={`${className}`}>{children}</div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
